import {
  CreateVerificationCriteriaTasksRequest,
  DeleteVerificationCriteriaTasksRequest,
  UpdateVerificationCriteriaTasksRequest,
  VerificationCriteriaTaskListResponse,
  VerificationCriteriaTaskResponse,
} from "@/backend/express/controllers/verificationCriteriaTask/verificationCriteriaTaskController";
import { VerificationCriteriaTaskParams } from "@/backend/access/verificationCriteriaTask/types";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class VerificationCriteriaTaskController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readByRequirementId(requirementId: string): Promise<VerificationCriteriaTaskListResponse> {
    return this.client.read(`/api/verification-criteria-tasks/requirement/${requirementId}`);
  }

  readReadyByProjectId(projectId: string): Promise<VerificationCriteriaTaskListResponse> {
    return this.client.read(`/api/verification-criteria-tasks/project/${projectId}`);
  }

  createMany(data: CreateVerificationCriteriaTasksRequest): Promise<VerificationCriteriaTaskListResponse> {
    return this.client.create('/api/verification-criteria-tasks', data);
  }

  update(task: VerificationCriteriaTaskParams): Promise<VerificationCriteriaTaskResponse> {
    return this.client.update(`/api/verification-criteria-tasks/${task.id}`, task);
  }

  updateMany(data: UpdateVerificationCriteriaTasksRequest): Promise<VerificationCriteriaTaskListResponse> {
    return this.client.update('/api/verification-criteria-tasks', data);
  }

  deleteMany(ids: string[]): Promise<FusaReply> {
    const body: DeleteVerificationCriteriaTasksRequest = { ids };
    return this.client.create('/api/verification-criteria-tasks/delete-many', body);
  }
}
